import { TmBaseError } from '@/core/error/tmBaseError'

export class TmEditorExtensionError extends TmBaseError {
  public name = 'TmEditorExtensionError'
}
